// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.firstName_cuuNP {
  display: inline-block;
  height: 25px;
  margin-top: 10px;
  text-align: flex-start;
  font-size: 16px;
}
.lastName_jxMnN {
  height: 25px;
  text-align: flex-start;
  font-size: 12px;
  font-weight: 400;
  color: #718096;
}
.container_EJZQq {
  margin-bottom: 15px;
}
.avatarImage_zB0uD {
  left: 20;
  vertical-align: top;
}
.spaceStyle_JmCBJ {
  left: 15;
}
.div_Pls0H {
  cursor: pointer;
  font-weight: 500;
  font-size: 15px;
  width: 100%;
  padding: 10px;
  border: 1px solid transparent;
}
.div_Pls0H:hover {
  background-color: #f0f0f0;
  border-color: #d9d9d9;
}
.divLog_KyyU1 {
  cursor: pointer;
  font-weight: 700;
  font-size: 15px;
  padding: 10px;
  border: 1px solid transparent;
}
.divLog_KyyU1:hover {
  background-color: #f0f0f0;
  border-color: #d9d9d9;
}
.space_ufhb8 {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.f11Text_bJyGM {
  margin-left: 0px;
  text-align: right;
}
.valid_qDhYg {
  color: green;
}
.valid_qDhYg:before {
  position: relative;
  left: -35px;
  content: '✔';
}
/* Add a red text color and an "x" when the requirements are wrong */
.invalid_K1jKS {
  color: #a94442;
}
.invalid_K1jKS:before {
  position: relative;
  left: -35px;
  content: '✖';
}
.validatemssageCom_wfq6K {
  margin-left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Profile/profile.less"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AACJ;AAEA;EACI,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAGA;EACI,mBAAA;AADJ;AAGA;EACI,QAAA;EACA,mBAAA;AADJ;AAGA;EACI,QAAA;AADJ;AAGA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;AADJ;AAEI;EACI,yBAAA;EACA,qBAAA;AAAR;AAIA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AAFJ;AAGI;EACI,yBAAA;EACA,qBAAA;AADR;AAKA;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AAHJ;AAKA;EACI,gBAAA;EACA,iBAAA;AAHJ;AAMA;EACI,YAAA;AAJJ;AAOA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AALJ;AACA,oEAAoE;AAOpE;EACI,cAAA;AALJ;AAQA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AANJ;AAQA;EACI,iBAAA;AANJ","sourcesContent":[".firstName {\n    display: inline-block;\n    height: 25px;\n    margin-top: 10px;\n    text-align: flex-start;\n    font-size: 16px;\n}\n\n.lastName {\n    height: 25px;\n    text-align: flex-start;\n    font-size: 12px;\n    font-weight: 400;\n    color: #718096;\n}\n\n.container {\n    margin-bottom: 15px;\n}\n.avatarImage {\n    left: 20;\n    vertical-align: top;\n}\n.spaceStyle {\n    left: 15;\n}\n.div {\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 15px;\n    width: 100%;\n    padding: 10px; // Add padding to make the hover area more noticeable\n    border: 1px solid transparent; // Optional: Add a border to see the hover effect clearly\n    &:hover {\n        background-color: #f0f0f0; // Change this to your desired hover color\n        border-color: #d9d9d9; // Optional: Change border color on hover\n    }\n}\n\n.divLog {\n    cursor: pointer;\n    font-weight: 700;\n    font-size: 15px;\n    padding: 10px; // Add padding to make the hover area more noticeable\n    border: 1px solid transparent; // Optional: Add a border to see the hover effect clearly\n    &:hover {\n        background-color: #f0f0f0; // Change this to your desired hover color\n        border-color: #d9d9d9; // Optional: Change border color on hover\n    }\n}\n\n.space {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.f11Text {\n    margin-left: 0px;\n    text-align: right;\n}\n\n.valid {\n    color: green;\n}\n\n.valid:before {\n    position: relative;\n    left: -35px;\n    content: '✔';\n}\n/* Add a red text color and an \"x\" when the requirements are wrong */\n.invalid {\n    color: #a94442;\n}\n\n.invalid:before {\n    position: relative;\n    left: -35px;\n    content: '✖';\n}\n.validatemssageCom {\n    margin-left: 20px;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"firstName": `firstName_cuuNP`,
	"lastName": `lastName_jxMnN`,
	"container": `container_EJZQq`,
	"avatarImage": `avatarImage_zB0uD`,
	"spaceStyle": `spaceStyle_JmCBJ`,
	"div": `div_Pls0H`,
	"divLog": `divLog_KyyU1`,
	"space": `space_ufhb8`,
	"f11Text": `f11Text_bJyGM`,
	"valid": `valid_qDhYg`,
	"invalid": `invalid_K1jKS`,
	"validatemssageCom": `validatemssageCom_wfq6K`
};
export default ___CSS_LOADER_EXPORT___;
